<div style="background-color: #2f3333; padding: 10px; color: #fff;">
  <div class="header">
    <h3 style="color: #fff" mat-dialog-title>Menus relacionados à sua busca:</h3>
    <mat-icon style="color: #fff" mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div class="menu-container">
    <ul style="list-style-type: none;" class="menu-list">
      <ng-container *ngIf="filteredItems.length > 0; else noResults">
        <ng-container *ngFor="let item of filteredItems">
          <li class="menu-item">
            <i [class]="item.icone + ' mr-2'"></i>
            <span class="menu-title">{{ item.nomeExibicao }}:</span>
            <ng-container *ngTemplateOutlet="Submenu; context: {$implicit: item.menuChildrenOutput}"></ng-container>
          </li>
        </ng-container>
      </ng-container>
    </ul>
    <ng-template #noResults>
      <div style="text-align: center; padding: 20px; color: #fff; display: flex; align-items: center; justify-content: center;">
        <mat-icon color="warn" class="icon-display" style="margin-right: 8px;">warning</mat-icon>
        Nenhum menu localizado para o seu usuário.
      </div>
    </ng-template>
  </div>
</div>

<ng-template #Submenu let-children>
  <ul style="list-style-type: circle;" *ngIf="children?.length" class="submenu-list">
    <li *ngFor="let child of children">
      <ng-container *ngIf="child.menuChildrenOutput && child.menuChildrenOutput.length; else clickableChild">
        <span class="submenu-text">
          <i [class]="child.icone + ' mr-2'"></i>
          {{ child.nomeExibicao }}
        </span>
        <ng-container *ngTemplateOutlet="Submenu; context: {$implicit: child.menuChildrenOutput}"></ng-container>
      </ng-container>
      <ng-template #clickableChild>
        <a [routerLink]="child.url" routerLinkActive="active" class="submenu-link">
          <i [class]="child.icone + ' mr-2'"></i>
          {{ child.nomeExibicao }}
        </a>
      </ng-template>
    </li>
  </ul>
</ng-template>
